import { SectionContainer } from "../atoms/containers/ContentContainers";
import { SectionFiveContent } from "../molecules/section_five_content/SectionFiveContent";

export function SectionFive() {
	return (
		<SectionContainer id="contact" variant="dark" field>
			<SectionFiveContent />
		</SectionContainer>
	);
}
